import { Route, Routes, Outlet } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { NominationFormContainer } from '@percent/grants-nomination-form/app/NominationForm/NominationFormContainer';
import { AppRoute } from './AppRoute.enum';
import { Confirmation } from '../app/Confirmation/Confirmation';
import { InvalidLink } from '../app/InvalidLink/InvalidLink';
import { SubmissionError } from '../app/SubmissionError/SubmissionError';
import { NominationFormContextController } from '../context/nominationForm/NominationFormContextController';
import { ThemeProvider } from '../providers/ThemeProvider/ThemeProvider';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const NominationFormContextWrapper = () => (
  <NominationFormContextController>
    <ThemeProvider>
      <Outlet />
    </ThemeProvider>
  </NominationFormContextController>
);

export const AppRoutes = () => (
  <SentryRoutes>
    <Route element={<NominationFormContextWrapper />}>
      <Route path={AppRoute.FORM_PAGE} element={<NominationFormContainer />} />
      <Route path={AppRoute.CONFIRMATION} element={<Confirmation />} />
      <Route path={AppRoute.SUBMISSION_ERROR} element={<SubmissionError />} />
      <Route path={AppRoute.NOT_FOUND} element={<InvalidLink />} />
    </Route>
  </SentryRoutes>
);
